// src/frontend/.../Recruitment/validation/section2.js
import errorTrackerV2 from "./Utils/ErrorTrackerV2";

export function validateSection2(data = {}) {
  const formData = data || {};
  const formErrors = {};

  // If data is null, all required fields are missing
  if (data === null || data === undefined) {
    formErrors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section2", formErrors);
    return formErrors;
  }

  // EXACT: Equity Release required (null/""/undefined)
  if (
    formData.Equity_Release === null ||
    formData.Equity_Release === "" ||
    formData.Equity_Release === undefined
  ) {
    formErrors["Equity_Release"] = "This field is required.";
  }

  // EXACT: Long Term Care required (null/""/undefined)
  if (
    formData.Long_Term_Care === null ||
    formData.Long_Term_Care === "" ||
    formData.Long_Term_Care === undefined
  ) {
    formErrors["Long_Term_Care"] = "This field is required.";
  }

  // ❌ EXACT: qualificationDetails logic remains NOT enforced (commented in original)

  // Set errors in tracker
  errorTrackerV2.setSectionErrors("section2", formErrors);

  return formErrors;
}
